/** @format */

import {BillingDiscountPeriod} from 'graphql/generated/types';

const getDurationMonths = (duration: BillingDiscountPeriod): number => {
  switch (duration) {
    case 'TWELVE_MONTHS':
      return 12;
    case 'THREE_MONTHS':
      return 3;
    case 'SIX_MONTHS':
      return 6;
    default:
      return 1;
  }
};

export {getDurationMonths};
